module.exports = __webpack_public_path__ + "img/0bc5203.png";